// index.js
import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/index'
import { camelCase } from 'lodash-es'

const requiredModules = require.context('./modules', false, /\.js$/)
const routers = {}
const routes = []
requiredModules.keys().forEach(fileName => {
  // 转为驼峰命名
  const moduleName = camelCase(fileName.replace(/(\.\/|\.js)/g, ''))
  routers[moduleName] =
    requiredModules(fileName).default || requiredModules(fileName)
})
Object.values(routers).forEach(router => {
  routes.push(...router)
})

Vue.use(Router)
const router = new Router({
  mode: 'history',
  routes,
  scrollBehavior (to, from, savePosition) {
    if (savePosition) {
      return savePosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})
/**
 * 原因：在路由中添加了相同的路由。
 * 重写路由的push方法
 */
const routerPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return routerPush.call(this, location).catch(error => error)
}

// 判断是否需要登录权限 以及是否登录
router.beforeEach((to, from, next) => {
  if (store.state.login._axiosPromiseCancel && store.state.login._axiosPromiseCancel.length) {
    store.state.login._axiosPromiseCancel.forEach(e => {
      e && e()
    })
    store.state.login._axiosPromiseCancel = []
  }
  if (!to.meta.authc && !to.matched.some(res => res.meta.authc)) {
    // 判断是否需要登录权限
    if (store.state.user.token) {
      // 判断是否登录
      next()
    } else {
      // 没登录则跳转到登录界面
      next({
        path: '/login'
      })
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js